module.exports = __webpack_public_path__ + "img/3.c75bf748.svg";